<template>
  <div class="btn-new-event" @click="btnClick()">
    <span class="btn-new-event-wrapper-icon">
        <Icon :name="item.iconName" class="btn-new-event-icon" v-bind:class="['CreateEvent' == item.name ? 'new-event-icon' : '']"></Icon>
    </span>
    <a class="btn-new-event-text">
      <span class="span-btn-text">{{item.btnText}}</span>
    </a>
  </div>
</template>

<script>
import 'vue-awesome/icons/plus';
import 'vue-awesome/icons/angle-double-right';
import Icon from 'vue-awesome/components/Icon';
import {mapActions} from 'vuex';
import consts from '../../_consts';

export default {
  name: 'button-sub-header-right',
  props: {
    item: {
      type: Object
    }
  },
  components: {
    Icon
  },
  data () {
    return {}
  },
  methods: {
    btnClick () {
      // Create User
      if (this.item.name === consts.subHeaderBtn.addUser.name) {
        let modalData = {
          action: consts.modalAction.createUser,
          data: null
        };
        this.$modal.show('eventModal', modalData);
      }
    },
    ...mapActions({
    })
  }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.btn-new-event {
  height: 26px;
  margin-left: 15px;
  &:hover{
    cursor: pointer;
  }
  .btn-new-event-wrapper-icon {
    height: 25px;
    width: 25px;
    float: left;
    border: 2px solid @blue;
    border-radius: 50px ;
    position: relative;
    top: -3px;
    .btn-new-event-icon {
      color: @blue;
      position: relative;
      top: -1px;
      right: -4px;
    }
    .new-event-icon{
      top: 3px;
      right: -4px;
    }
  }
  .btn-new-event-text {
    .span-btn-text {
      color: @blue;
      font-family: @font-family-main;
    }
    // position: relative;
    height: 17px;
    width: 68px;
    font-size: 14px;
    font-weight: 600;
    top: -4px;
      margin: 0 0 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// SubHeaderButton.vue?1cbdb65f